module.exports = __webpack_public_path__ + "img/giftwrap-banner.22c8d44.jpg";